<template>
  <div
    :style="`height: ${size}px; min-width: ${size}px; width: ${size}px;`"
    v-html="iconName"
    class="sxIcon"
    data-component="icon"
  />
</template>

<script>
const iconRadioCircle = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 5C7.24 5 5 7.24 5 10C5 12.76 7.24 15 10 15C12.76 15 15 12.76 15 10C15 7.24 12.76 5 10 5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" fill="currentcolor"/>
</svg>`;

const iconCheckCircle = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z" fill="currentcolor"/>
</svg>`;

const iconMenu = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_296_976)">
    <path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z" fill="currentcolor"/>
  </g>
  <defs>
  <clipPath id="clip0_296_976">
    <rect width="24" height="24" fill="white"/>
  </clipPath>
  </defs>
</svg>`;

const iconClose = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_296_979)">
    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_296_979">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

const iconArrowLeft = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 0L9.41 1.41L3.83 7H16V9H3.83L9.41 14.59L8 16L0 8L8 0Z" fill="currentcolor"/>
</svg>`;

const iconSend = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_294_940)">
    <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_294_940">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

const iconSquare = `<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path id="icon-square" d="M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z" fill="currentcolor"/>
</svg>`;

const iconNotifications = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_294_967)">
    <path d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_294_967">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

const iconCheckSquare = `<svg  viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.11 18 18 17.1 18 16V2C18 0.9 17.11 0 16 0ZM7 14L2 9L3.41 7.59L7 11.17L14.59 3.58L16 5L7 14Z" fill="currentcolor"/>
</svg>`;

const iconNotificationsActive = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_294_964)">
    <path d="M7.58003 4.08L6.15003 2.65C3.75003 4.48 2.17003 7.3 2.03003 10.5H4.03003C4.18003 7.85 5.54003 5.53 7.58003 4.08ZM19.97 10.5H21.97C21.82 7.3 20.24 4.48 17.85 2.65L16.43 4.08C18.45 5.53 19.82 7.85 19.97 10.5ZM18 11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63003 5.36 6.00003 7.92 6.00003 11V16L4.00003 18V19H20V18L18 16V11ZM12 22C12.14 22 12.27 21.99 12.4 21.96C13.05 21.82 13.58 21.38 13.84 20.78C13.94 20.54 13.99 20.28 13.99 20H9.99003C10 21.1 10.89 22 12 22Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_294_964">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

const iconEdit = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_294_937)">
    <path d="M3 17.2501V21.0001H6.75L17.81 9.94006L14.06 6.19006L3 17.2501ZM20.71 7.04006C21.1 6.65006 21.1 6.02006 20.71 5.63006L18.37 3.29006C17.98 2.90006 17.35 2.90006 16.96 3.29006L15.13 5.12006L18.88 8.87006L20.71 7.04006Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_294_937">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

const iconComment = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_294_961)">
  <path d="M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4C22 2.9 21.1 2 20 2ZM18 14H6V12H18V14ZM18 11H6V9H18V11ZM18 8H6V6H18V8Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_294_961">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

const iconCircle = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" fill="currentcolor"/>
</svg>`;

const iconTimeAdd = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_294_929)">
    <path d="M10 8V14L14.7 16.9L15.5 15.7L11.5 13.3V8H10Z" fill="currentcolor"/>
    <path d="M17.92 12C17.97 12.33 18 12.66 18 13C18 16.9 14.9 20 11 20C7.1 20 4 16.9 4 13C4 9.1 7.1 6 11 6C11.7 6 12.37 6.1 13 6.29V4.23C12.36 4.08 11.69 4 11 4C6 4 2 8 2 13C2 18 6 22 11 22C16 22 20 18 20 13C20 12.66 19.98 12.33 19.94 12H17.92Z" fill="currentcolor"/>
    <path d="M20 5V2H18V5H15V7H18V10H20V7H23V5H20Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_294_929">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

const iconTimeLapse = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.53501 15.8425L10.232 10.0042V2.0033C10.1549 2.0011 10.0776 2 10 2C5.58172 2 2 5.58172 2 10C2 12.3052 2.97496 14.3826 4.53501 15.8425ZM19.9059 8.62255C19.6221 6.54111 18.6974 4.53343 17.1305 2.93456C15.2269 0.983744 12.7376 0 10.232 0V0.00263846C10.1549 0.000882654 10.0775 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C10.0397 20 10.0793 19.9998 10.1189 19.9993C12.6565 20.0297 15.2057 19.0546 17.1468 17.0738C19.0852 15.0873 20.0367 12.4698 19.9991 9.8639C19.9935 9.44334 19.9619 9.02904 19.9059 8.62255Z" fill="currentcolor"/>
</svg>`;

const iconFileUpload = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_294_923)">
    <path d="M9 16H15V10H19L12 3L5 10H9V16ZM5 18H19V20H5V18Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_294_923">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

const iconNotInterested = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_294_926)">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 10.15 4.63 8.45 5.69 7.1L16.9 18.31C15.55 19.37 13.85 20 12 20ZM18.31 16.9L7.1 5.69C8.45 4.63 10.15 4 12 4C16.42 4 20 7.58 20 12C20 13.85 19.37 15.55 18.31 16.9Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_294_926">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

const iconPerson = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_294_970)">
    <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_294_970">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

const iconError = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="currentcolor"/>
</svg>`;

const iconAdd = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_328_999)">
    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_328_999">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

const iconCaretDown = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_418_920)">
    <path d="M7.41 8.59003L12 13.17L16.59 8.59003L18 10L12 16L6 10L7.41 8.59003Z" fill="currentcolor"/>
  </g>
  <defs>
  <clipPath id="clip0_418_920">
    <rect width="24" height="24" fill="white"/>
  </clipPath>
  </defs>
</svg>`;

const iconCaretUp = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_418_917)">
    <path d="M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z" fill="currentcolor"/>
  </g>
  <defs>
  <clipPath id="clip0_418_917">
    <rect width="24" height="24" fill="white"/>
  </clipPath>
  </defs>
</svg>`;

const iconRemove = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_447_100)">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H7V11H17V13Z" fill="currentcolor"/>
  </g>
  <defs>
  <clipPath id="clip0_447_100">
    <rect width="24" height="24" fill="white"/>
  </clipPath>
  </defs>
</svg>`;

const iconFolder = `<svg viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2H10L8 0Z" fill="currentcolor"/>
</svg>`;

const iconFolderEmpty = `<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 2H10L8 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2ZM18 14H2V4H18V14Z" fill="currentcolor"/>
</svg>`;

const iconWarning = `<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 19H22L11 0L0 19ZM12 16H10V14H12V16ZM12 12H10V8H12V12Z" fill="currentcolor"/>
</svg>
`;

const iconCloudUpload = `<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M19.35 6.04C18.67 2.59 15.64 0 12 0C9.11 0 6.6 1.64 5.35 4.04C2.34 4.36 0 6.91 0 10C0 13.31 2.69 16 6 16H19C21.76 16 24 13.76 24 11C24 8.36 21.95 6.22 19.35 6.04ZM14 9V13H10V9H7L12 4L17 9H14Z" fill="currentcolor"/>
</svg>`;

const iconNumberedList = `<svg viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 13H2V13.5H1V14.5H2V15H0V16H3V12H0V13ZM1 4H2V0H0V1H1V4ZM0 7H1.8L0 9.1V10H3V9H1.2L3 6.9V6H0V7ZM5 1V3H19V1H5ZM5 15H19V13H5V15ZM5 9H19V7H5V9Z" fill="currentcolor"/>
</svg>`;

const iconList = `<svg viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 6H2V4H0V6ZM0 10H2V8H0V10ZM0 2H2V0H0V2ZM4 6H18V4H4V6ZM4 10H18V8H4V10ZM4 0V2H18V0H4Z" fill="currentcolor"/>
</svg>`;

const iconSubdir = `<svg viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 11L9 17L7.58 15.58L11.17 12H0V0H2V10H11.17L7.58 6.42L9 5L15 11Z" fill="currentcolor"/>
</svg>`;

const iconTrash = `<svg viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1ZM1 4V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1ZM4 7H6V15H4V7ZM10 7H8V15H10V7Z" fill="currentcolor"/>
</svg>`;

const iconCheck = `<svg viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.00016 11.1698L1.83016 6.99984L0.410156 8.40984L6.00016 13.9998L18.0002 1.99984L16.5902 0.589844L6.00016 11.1698Z" fill="currentcolor"/>
</svg>`;

const iconArrowRight = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="currentcolor"/>
</svg>`;

const iconSwitch = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.6865 10.6429H8.10811V12.7857H15.6865V16L20 11.7143L15.6865 7.42857V10.6429ZM4.31351 9.57143V6.35714H11.8919V4.21429H4.31351V1L0 5.28571L4.31351 9.57143Z" fill="currentcolor"/>
</svg>`;

const iconFile = `<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 0H2C0.9 0 0.0100002 0.9 0.0100002 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0ZM14 18H2V2H9V7H14V18Z" fill="currentcolor"/>`;

const iconPrint = `<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 5H3C1.34 5 0 6.34 0 8V14H4V18H16V14H20V8C20 6.34 18.66 5 17 5ZM14 16H6V11H14V16ZM17 9C16.45 9 16 8.55 16 8C16 7.45 16.45 7 17 7C17.55 7 18 7.45 18 8C18 8.55 17.55 9 17 9ZM16 0H4V4H16V0Z" fill="currentcolor"/>
</svg>`;

const iconNA = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 8.15 2.63 6.45 3.69 5.1L14.9 16.31C13.55 17.37 11.85 18 10 18ZM16.31 14.9L5.1 3.69C6.45 2.63 8.15 2 10 2C14.42 2 18 5.58 18 10C18 11.85 17.37 13.55 16.31 14.9Z" fill="currentcolor"/>
</svg>`;

const iconVerified = `<svg viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 0L0 4V10C0 15.55 3.84 20.74 9 22C14.16 20.74 18 15.55 18 10V4L9 0ZM7 16L3 12L4.41 10.59L7 13.17L13.59 6.58L15 8L7 16Z" fill="currentcolor"/>
</svg>`;

export default {
  props: {
    size: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconName() {
      /*
      NOTE @chris
      Later this should be `const ICONS: Record<IconType, string> = {}` to ensure type safety;
      Setting this up this way is both good for performance and good for setting design constraints early.
      */
      const ICONS = {
        'arrow-left': iconArrowLeft,
        'arrow-right': iconArrowRight,
        'caret-down': iconCaretDown,
        'caret-up': iconCaretUp,
        'check-circle': iconCheckCircle,
        'check-square': iconCheckSquare,
        'cloud-upload': iconCloudUpload,
        'error-circle': iconError,
        'file-upload': iconFileUpload,
        'not-interested': iconNotInterested,
        'notifications-active': iconNotificationsActive,
        'numbered-list': iconNumberedList,
        'radio-circle': iconRadioCircle,
        'time-add': iconTimeAdd,
        'time-lapse': iconTimeLapse,
        add: iconAdd,
        check: iconCheck,
        circle: iconCircle,
        close: iconClose,
        comment: iconComment,
        edit: iconEdit,
        file: iconFile,
        folder: iconFolder,
        folderEmpty: iconFolderEmpty,
        list: iconList,
        menu: iconMenu,
        na: iconNA,
        notifications: iconNotifications,
        person: iconPerson,
        print: iconPrint,
        remove: iconRemove,
        send: iconSend,
        square: iconSquare,
        subdir: iconSubdir,
        switch: iconSwitch,
        trash: iconTrash,
        verified: iconVerified,
        warning: iconWarning,
      };

      return ICONS[this.name];
    },
  },
};
</script>

<style lang="css">
.sxIcon,
.sxIcon svg {
  align-items: center;
  display: flex;
  justify-content: center;
}

.sxIcon svg {
  height: 100%;
  min-width: 100%;
  width: 100%;

  color: currentcolor;
}
</style>
